export default {
  title: '본인 부담금',
  description: '본인 부담금은 보험 계획에 정의된 대로, 보험이 적용되는 의료 서비스나 처방약에 대해 귀하가 지불해야 하는 특정 금액입니다.',
  'is-paid': '지불됨',
}
